import React, { ReactElement, ReactNode } from 'react';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

const useStyles = makeStyles({
  heading: {
    fontSize: 20,
    fontWeight: 'bold',
    padding: '24px 24px 0 24px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 16,
  },
});

type ModalProps = {
  children: ReactNode;
  open: boolean;
  title: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  onClose(): void;
} & DialogProps;

export const Modal = ({
  children,
  open,
  title,
  maxWidth = 'xs',
  onClose,
  ...props
}: ModalProps): ReactElement => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={maxWidth}
      fullWidth
      {...props}
    >
      <Typography id="alert-dialog-title" className={classes.heading}>
        {title}
      </Typography>
      <DialogContent className={classes.content}>{children}</DialogContent>
      <DialogActions>
        <Box
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          paddingX="20px"
          paddingY="20px"
        >
          <Button
            onClick={onClose}
            color="primary"
            variant="contained"
            size="medium"
            startIcon={<ChevronLeftIcon />}
          >
            Go Back
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
